/* eslint-disable react/jsx-props-no-spreading */
import { FC, useContext } from 'react';
import { Stack } from '@mantine/core';
import { useLocation } from 'react-router-dom';
import { DocumentContext } from '../../../Service/Context/DocumentContextV2';
import { DocumentTemplateContext } from '../../../Service/Context/DocumentTemplateContext';
import { PositionDto } from '../../../Service/DocumentT';
import PositionGroup from './DocumentPositionGroup';

interface Props {
  usePreviewVersion: boolean;
  products: PositionDto[];
}

const PositionGroups: FC<Props> = (props) => {
  const { pathname } = useLocation();
  if (pathname.includes('settings')) {
    // Template scope
    return <TemplatePositionGroups {...props} />;
  }
  // Document scope
  return <DocumentPositionGroups {...props} />;
};

const TemplatePositionGroups: FC<Props> = ({ usePreviewVersion, products }) => {
  const { bookitupDocument, positionHandlers, groupHandlers } = useContext(DocumentTemplateContext);
  const positionGroups = bookitupDocument?.positionGroups ?? [];

  if (!bookitupDocument) {
    return null;
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {positionGroups.length > 0 && (
        <Stack spacing="xs">
          {positionGroups.map((group, idx) => (
            <PositionGroup
              key={group.id}
              idx={idx}
              group={group}
              bookitupDocument={bookitupDocument}
              positionHandlers={positionHandlers}
              groupHandlers={groupHandlers}
              usePreviewVersion={usePreviewVersion}
              products={products}
            />
          ))}
        </Stack>
      )}
    </>
  );
};

const DocumentPositionGroups: FC<Props> = ({ usePreviewVersion, products }) => {
  const { bookitupDocument, positionHandlers, groupHandlers } = useContext(DocumentContext);
  const positionGroups = bookitupDocument?.positionGroups ?? [];

  if (!bookitupDocument) {
    return null;
  }
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {positionGroups.length > 0 && (
        <Stack spacing="xs">
          {positionGroups.map((group, idx) => (
            <PositionGroup
              key={group.id}
              idx={idx}
              group={group}
              bookitupDocument={bookitupDocument}
              positionHandlers={positionHandlers}
              groupHandlers={groupHandlers}
              usePreviewVersion={usePreviewVersion}
              products={products}
            />
          ))}
        </Stack>
      )}
    </>
  );
};

export default PositionGroups;
